export default {
  login: {
    title: 'Accès Sécurisé',
    subtitle: 'Connectez-vous à votre cockpit',
    emailLabel: 'Identifiant Email',
    emailPlaceholder: 'votre@ekose.rx',
    passwordLabel: "Clé d'Accès",
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Oublié ?',
    submitButton: 'Authentification',
    lockedButton: 'Accès Restreint',
    orContinueWith: 'Ou continuer avec',
    noAccount: 'Pas encore de cockpit ?',
    createAccount: 'Créer un compte',
    biometricReady: 'Biometric Ready',
    hdsCompliant: 'HDS Compliant',
    brand: 'EKOSE',
    tagline: 'Plateforme Médicale Haute Performance',
    errors: {
      unrecognized: 'Identifiants non reconnus. {{count}} tentative(s) avant verrouillage.',
      lockout: 'Sécurité : Protocole de verrouillage activé. Réessayez dans {{count}} minute(s).',
      lockoutImmediate: 'Trop de tentatives. Compte verrouillé pour 5 minutes.',
      authContextMissing: "Le contexte d'authentification n'est pas disponible.",
      tooManyAttempts: 'Trop de tentatives. Réessayez dans {{count}} minute(s).',
      unknownError: 'Une erreur inattendue est survenue. Veuillez réessayer.'
    },
    emailRequired: "L'email est requis.",
    emailInvalid: "Format d'email invalide.",
    passwordRequired: "Le mot de passe est requis.",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères.",
    platformSubtitle: "Plateforme de téléconsultation médicale",
    personalSpaceSubtitle: "Accédez à votre espace personnel",
    rememberMe: "Se souvenir de moi",
    forgotPasswordFull: "Mot de passe oublié ?",
    connecting: "Connexion en cours...",
    sessionDurationInfo: "Votre session sera maintenue pendant 30 jours",
    testAccountsTitle: "Comptes de test :",
    testDoctor: "👨‍⚕️ Médecin: dr.martin@ekose.com / password123",
    testAdmin: "🏥 Admin: admin@ekose.com / password123",
    testPatient: "👤 Patient: patient1@ekose.com / password123"
  },
  register: {
    title: 'Rejoindre',
    brand: 'Ekose.Rx',
    subtitle: 'Initialisation de votre profil de santé',
    roleLabel: 'Choisissez votre accès',
    roles: {
      patient: 'Patient',
      patientDesc: 'Soins & Suivi',
      doctor: 'Praticien',
      doctorDesc: 'Expertise & Cabinets'
    },
    nameLabel: 'Nom Complet',
    namePlaceholder: 'Paul Dupont',
    emailLabel: 'Adresse Email',
    emailPlaceholder: 'votre@ekose.rx',
    passwordLabel: "Clé d'Accès",
    passwordPlaceholder: '••••••••',
    submitButton: "Lancer l'Onboarding",
    orContinueWith: 'Ou continuer avec',
    alreadyMember: "Déjà membre de l'élite ?",
    loginLink: 'Se connecter',
    hdsSecured: 'HDS Secured',
    privacyFirst: 'Privacy First',
    activePulse: 'Active Pulse',
    dateOfBirthLabel: 'Date de Naissance (Patients)',
    genderLabel: 'Genre (Patients)',
    genderPlaceholder: 'Sélectionner le genre...',
    genders: {
      male: 'Homme',
      female: 'Femme',
      other: 'Autre'
    },
    errors: {
      authContextMissing: "Le contexte d'authentification n'est pas disponible.",
      formErrors: 'Veuillez corriger les erreurs dans le formulaire',
      emailTaken: 'Cet email est déjà utilisé',
      unknownError: 'Une erreur inattendue est survenue lors de la création de votre compte.'
    }
  },
  mfa: {
    setupTitle: "Sécurisez votre compte",
    setupSubtitle: "Activez l'authentification à deux facteurs",
    setupInstructions: "Scannez ce QR code avec votre application d'authentification",
    qrCodePlaceholder: "L'affichage du QR Code nécessite l'installation de qrcode.react.",
    backupCodesTitle: "Codes de secours",
    backupCodesInstructions: "Conservez ces codes en lieu sûr. Vous en aurez besoin si vous perdez votre téléphone.",
    show: "Afficher",
    hide: "Masquer",
    copy: "Copier",
    copied: "Copié",
    download: "Télécharger",
    cancel: "Annuler",
    continue: "Continuer",
    verifyTitle: "Vérification",
    verifySubtitle: "Entrez le code de votre application d'authentification",
    verificationCodeLabel: "Code de vérification",
    verificationCodePlaceholder: "000000",
    verifyBtn: "Vérifier",
    verifying: "Vérification...",
    useBackupCode: "Utiliser un code de secours",
    backupCodeLabel: "Code de secours",
    backupCodePlaceholder: "Entrez un code de secours",
    useBackupCodeBtn: "Utiliser le code de secours",
    completeTitle: "MFA Activé !",
    completeSubtitle: "Votre compte est maintenant sécurisé avec l'authentification à deux facteurs.",
    finishBtn: "Terminer",
    initializingToast: "Configuration MFA initialisée",
    initErrorToast: "Erreur lors de l'initialisation MFA",
    enterCodeToast: "Veuillez entrer le code de vérification",
    successToast: "MFA activé avec succès !",
    incorrectCodeToast: "Code de vérification incorrect",
    verificationErrorToast: "Erreur lors de la vérification MFA",
    enterBackupCodeToast: "Veuillez entrer un code de secours",
    incorrectBackupCodeToast: "Code de secours incorrect",
    backupCodeErrorToast: "Erreur lors de la vérification du code de secours",
    codesCopiedToast: "Codes de secours copiés",
    codesDownloadedToast: "Codes de secours téléchargés",
    loadingText: "Configuration de l'authentification multi-facteurs..."
  },
  verification: {
    loading: "Vérification de l'authentification...",
    roleMissing: "Rôle manquant - redirection vers login",
    unauthorized: "Accès refusé - rôle insuffisant",
    unauthorizedPermissions: "Accès refusé - permissions insuffisantes",
    missingRoleLog: "Rôle utilisateur manquant"
  }
};
